import React from "react";
import { Card, Container, Row, Col, Button } from "react-bootstrap";

const InfoCards = () => {
    return (
        <section id="reach" >
            <Container className="mt-4">
                <Row className="justify-content-center">
                    {/* First Card */}
                    <Col md={5} className="mb-3">
                        <Card
                            style={{
                                background: "linear-gradient(90.21deg, #AA367C -5.91%, #4A2FBD 111.58%)",
                                border: "none",
                                boxShadow: "none",
                                color: "black",
                                padding: "20px",
                                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                            }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.transform = "scale(1.05)";
                                e.currentTarget.style.boxShadow = "0px 4px 15px rgba(0, 0, 0, 0.3)";
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.transform = "scale(1)";
                                e.currentTarget.style.boxShadow = "none";
                            }}
                        >
                            <Card.Body style={{ color: "white" }}>
                                <h5 style={{ fontWeight: "bold" }}>Reach Us</h5>
                                <ul >
                                    <li>Click the Bus Route button below to view full details.</li>
                                    <li>For more information about transportation, please contact +91 70103 96731, +91 63793 62078.</li>
                                </ul>
                                <Button
                                    className="btn btn-danger"
                                    style={{ float: "right" }}
                                    onClick={() => window.open("/BR.pdf", "_blank")}
                                >
                                    Bus route
                                </Button>

                            </Card.Body>
                        </Card>
                    </Col>

                    {/* Second Card */}
                    <Col md={5} className="mb-3">
                        <Card
                            style={{
                                background: "linear-gradient(90.21deg, #AA367C -5.91%, #4A2FBD 111.58%)",
                                border: "none",
                                boxShadow: "none",
                                color: "black",
                                padding: "20px",
                                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                height: "200px"
                            }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.transform = "scale(1.05)";
                                e.currentTarget.style.boxShadow = "0px 4px 15px rgba(0, 0, 0, 0.3)";
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.transform = "scale(1)";
                                e.currentTarget.style.boxShadow = "none";
                            }}
                        >
                            <Card.Body style={{ color: "white" }}>
                                <h5 style={{ fontWeight: "bold" }}>Instructions</h5>
                                <ul >
                                    <li>All participants must wear formal attire.</li>
                                    <li>All participants must bring their college ID card.</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>

        </section>
    );
};

export default InfoCards;
